import React from 'react'
import reducer from './store'
import { injectReducer } from 'store/index'
import { AdaptableCard } from 'components/shared'
import { useTranslation } from 'react-i18next';
import SocialNetworkTable from './components/SocialNetworkTable'
import SocialNetworkTableTools from './components/SocialNetworkTableTools'

injectReducer('socialnetworksList', reducer)

const SocialNetworkList = () => {
	const { t } = useTranslation();
	return (
		<AdaptableCard className="h-full" bodyClass="h-full">
			<div className="lg:flex items-center justify-between mb-4">
				<h3 className="mb-4 lg:mb-0">{t('translation.SocialNetwork')}</h3>
				<SocialNetworkTableTools />
			</div>
			<SocialNetworkTable />
		</AdaptableCard>
	)
}

export default SocialNetworkList